import React from 'react';
import { Menu, MenuItem, MenuProps } from '@mui/material';
import './Dropdown.css';

export interface DropdownOption {
  label: string;
  value: string;
  color?: 'default' | 'danger' | 'secondary';
  disabled?: boolean;
  onClick: () => void;
}

export interface DropdownProps {
  anchorEl: null | HTMLElement;
  open: boolean;
  onClose: () => void;
  options: DropdownOption[];
  className?: string;
  anchorOrigin?: MenuProps['anchorOrigin'];
  transformOrigin?: MenuProps['transformOrigin'];
  minWidth?: number | string;
}

const Dropdown: React.FC<DropdownProps> = ({
  anchorEl,
  open,
  onClose,
  options,
  className,
  minWidth,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'right',
  },
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      className={`dropdown-menu ${className}`}
      classes={{
        paper: 'dropdown-paper',
        list: 'dropdown-list',
      }}
      slotProps={{
        paper: {
          sx: {
            width: minWidth ? (typeof minWidth === 'number' ? `${minWidth}px` : minWidth) : (anchorEl ? `${anchorEl.offsetWidth}px` : 'auto'),
            minWidth: minWidth ? (typeof minWidth === 'number' ? `${minWidth}px` : minWidth) : (anchorEl ? `${anchorEl.offsetWidth}px` : 'auto'),
            maxWidth: 'none',
          },
        },
      }}
    >
      {options.map((option) => {
        const colorClass = option.color === 'danger' ? 'danger' : option.color === 'secondary' ? 'secondary' : '';
        return (
          <MenuItem
            key={option.value}
            onClick={option.disabled ? undefined : option.onClick}
            disabled={option.disabled}
            className={`dropdown-option ${colorClass}`}
            tabIndex={0}
          >
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', width: '100%', maxWidth: '100%' }}>
              {option.label}
            </span>
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default Dropdown;

